import {
  Badge,
  Box,
  Center,
  Group,
  Loader,
  Text,
} from "@mantine/core";
import { IconMail } from "@tabler/icons";

export function PreviewPanel({
  html,
  isLoading,
}: {
  html: string;
  isLoading: boolean;
}) {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 140px)",
        borderRadius: theme.radius.md,
        overflow: "hidden",
        border: `1px solid ${
          theme.colorScheme === "dark"
            ? theme.colors.dark[4]
            : theme.colors.gray[2]
        }`,
      })}
    >
      {/* Preview toolbar */}
      <Box
        sx={(theme) => ({
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px 16px",
          borderBottom: `1px solid ${
            theme.colorScheme === "dark"
              ? theme.colors.dark[4]
              : theme.colors.gray[2]
          }`,
          backgroundColor:
            theme.colorScheme === "dark"
              ? theme.colors.dark[7]
              : theme.white,
          flexShrink: 0,
        })}
      >
        <Group spacing="xs">
          <IconMail size={14} style={{ opacity: 0.5 }} />
          <Text size="xs" weight={600} sx={{ letterSpacing: "0.03em", textTransform: "uppercase", opacity: 0.6 }}>
            Email Preview
          </Text>
        </Group>
        <Badge
          size="xs"
          variant="dot"
          color={isLoading ? "yellow" : "teal"}
          sx={{ textTransform: "none" }}
        >
          {isLoading ? "Updating..." : "Live"}
        </Badge>
      </Box>

      {/* Preview canvas */}
      <Box
        sx={(theme) => ({
          flex: 1,
          overflow: "auto",
          backgroundColor:
            theme.colorScheme === "dark"
              ? theme.colors.dark[8]
              : "#f0f0f0",
          backgroundImage:
            theme.colorScheme === "dark"
              ? "none"
              : "radial-gradient(circle, #d9d9d9 1px, transparent 1px)",
          backgroundSize: "20px 20px",
          display: "flex",
          justifyContent: "center",
          padding: "24px 16px",
          position: "relative",
        })}
      >
        {isLoading && !html && (
          <Center sx={{ position: "absolute", inset: 0 }}>
            <Loader size="sm" color="gray" />
          </Center>
        )}
        {html ? (
          <Box
            sx={(theme) => ({
              width: "100%",
              maxWidth: 640,
              backgroundColor: "#fff",
              borderRadius: theme.radius.sm,
              boxShadow: "0 4px 24px rgba(0,0,0,0.08), 0 1px 4px rgba(0,0,0,0.04)",
              overflow: "hidden",
              flexShrink: 0,
              position: "relative",
              opacity: isLoading ? 0.6 : 1,
              transition: "opacity 150ms ease",
            })}
          >
            <iframe
              srcDoc={html}
              style={{
                width: "100%",
                height: "calc(100vh - 240px)",
                border: "none",
                display: "block",
                background: "#fff",
              }}
              title="Email Preview"
            />
          </Box>
        ) : (
          !isLoading && (
            <Center sx={{ flex: 1 }}>
              <Box sx={{ textAlign: "center" }}>
                <IconMail size={36} color="#bbb" style={{ marginBottom: 12 }} />
                <Text color="dimmed" size="sm">
                  Preview will appear here as you edit
                </Text>
              </Box>
            </Center>
          )
        )}
      </Box>
    </Box>
  );
}
